var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTutorial = function SvgTutorial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.573 13.323v3.487c0 .247.091.485.289.634.623.47 2.322 1.443 5.723 1.443 3.4 0 5.099-.972 5.723-1.443.197-.15.289-.387.289-.634v-3.645l-5.82 2.861a1 1 0 0 1-.893-.005l-5.311-2.698Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.93 5.176a1 1 0 0 1 .8-.004L21 8.716a1 1 0 0 1 .048 1.816l-8.27 4.067a1 1 0 0 1-.894-.006l-8.007-4.067a1 1 0 0 1 .048-1.806l8.006-3.544Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4.694 10.25h-.847v2.782a1.27 1.27 0 1 0 .847 0V10.25Z"
  })));
};
export default SvgTutorial;